import { mainColor, _THEME } from "../theme";

const mobileNoticeStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 20,
    background: "hsla(186, 33%, 94%, 1)",
    backgroundImage:
      "radial-gradient(circle at center, hsla(186, 33%, 94%, 1) 0%, hsla(216, 41%, 79%, 1) 100%)",
    position: "fixed",
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: "100vh",
    width: "100vw",
    padding: 24,
    boxSizing: "border-box",
    textAlign: "center",
  },
  icon: {
    fontSize: 96,
    color: mainColor,
    marginBottom: 4,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: _THEME.color.text.main,
    margin: 0,
    lineHeight: 1.3,
  },
  text: {
    fontSize: 16,
    fontWeight: 300,
    color: _THEME.color.text.main,
    margin: 0,
    maxWidth: 320,
    lineHeight: 1.6,
  },
  badgesContainer: {
    display: "flex",
    gap: 10,
    marginTop: 8,
  },
  badge: {
    fontSize: 13,
    fontWeight: 400,
    color: "#444",
    background: "rgba(255, 255, 255, 0.75)",
    border: "1px solid rgba(32, 156, 241, 0.25)",
    padding: "6px 14px",
    borderRadius: 20,
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.04)",
  },
};

export default mobileNoticeStyles;
